import { render } from "./ModalBackButton.vue?vue&type=template&id=0089dfc8&scoped=true&lang=pug"
import script from "./ModalBackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBackButton.vue?vue&type=script&setup=true&lang=js"

import "./ModalBackButton.vue?vue&type=style&index=0&id=0089dfc8&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0089dfc8"]])

export default __exports__